"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";
import QueryString from "qs";

const controlPointsService = {
  getControlPoints: function (options) {
    return api.get(
      "/ControlPoints",
      WithToken.headersToken(
        {
          params: options,
          paramsSerializer: (params) => {
            return QueryString.stringify(params);
          },
        },
        configuration.cookieName
      )
    );
  },
  createControlPoint: function (options) {
    return api.post(`/ControlPoints`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteControlPoint: function (options) {
    return api.delete(`/ControlPoints`, WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
  updateControlPoint: function (options) {
    return api.put("/ControlPoints/" + options.id, options, WithToken.headersToken({}, configuration.cookieName));
  },
};

export default controlPointsService;
